import { ApolloClient } from "@apollo/client";
import { type PaginationContext, type LoadResult } from "../../common/state";
import { LensesRepositoryV2 } from "../models";

export const loadLenses =
    (client: ApolloClient<any>) =>
    ({ limit }: PaginationContext): Promise<LoadResult> =>
        new LensesRepositoryV2(client).loadLensesToCache({ limit }).then((lensesList) => ({
            isLastPage: !lensesList?.hasMore,
        }));
